const inlineMenu = document.querySelector('.header__inline-menu');

if (inlineMenu) {
  const CLOSE_DELAY = 200;
  const menuItems = [...inlineMenu.querySelectorAll('details')];
  const closeTimers = new Map();

  const setOpen = (item, open) => {
    clearTimeout(closeTimers.get(item));
    item.toggleAttribute('open', open);
    item.querySelector('summary')?.setAttribute('aria-expanded', String(open));
  };

  const openItem = (item) => {
    menuItems.forEach((other) => {
      if (other !== item && other.hasAttribute('open')) setOpen(other, false);
    });
    setOpen(item, true);
  };

  const scheduleClose = (item) => {
    clearTimeout(closeTimers.get(item));
    closeTimers.set(item, setTimeout(() => setOpen(item, false), CLOSE_DELAY));
  };

  menuItems.forEach((item) => {
    item.addEventListener('mouseenter', () => openItem(item));
    item.addEventListener('mouseleave', () => scheduleClose(item));
  });
}
